/**
 * Helper functions to support the browser native full-screen API
 *
 * @packageDocumentation
 */

import { logger } from 'utils/system/logger'

/**
 * request full screen API for multiple, non-spec named browser implementations on specified element
 * @param {Nullable<HTMLElement>}
 */
export const activateFullScreen = async (el: HTMLElement): Promise<void> => {
    // W3C spec
    if (el.requestFullscreen) {
        return el.requestFullscreen().catch((e) => logger('error', e))
    }
    // Firefox
    if (el.mozRequestFullScreen) {
        return el.mozRequestFullScreen()
    }
    // Safari
    if (el.webkitRequestFullscreen) {
        return el.webkitRequestFullscreen()
    }

    // IE/Edge
    if (el.msRequestFullscreen) {
        return el.msRequestFullscreen()
    }
}

/**
 *  exit full screen API for multiple, non-spec named browser implementations on document
 */
export const deactivateFullscreen = async (): Promise<void> => {
    // W3C spec
    if (document.exitFullscreen) {
        return document.exitFullscreen().catch((e) => logger('error', e))
    }
    // Firefox
    if (document.mozCancelFullScreen) {
        return document.mozCancelFullScreen()
    }
    // Safari
    if (document.webkitExitFullscreen) {
        return document.webkitExitFullscreen()
    }
    // IE/Edge
    if (document.msExitFullscreen) {
        return document.msExitFullscreen()
    }
}
